export const screenType = {
  agent: 2,
  client: 1,
  publisher: 3,
  staff: 4
};

export const registerStatus = {
  deleted: 99,
  emailRegistered: 2,
  finished: 1,
  passwordRegistered: 3
};

export const role = {
  admin: 1,
  member: 2
};

export const select = {
  other: 99
};

export const selectKpi = {
  acquisition: 3,
  interest: 1,
  other: 99,
  promotion: 4,
  understanding: 2
};

export const status = {
  approved: 1,
  deleted: 0,
  fix: 3,
  notChecked: 2
};

export const contact = {
  fromLogin: 'login',
  fromMedia: 'media',
  fromOther: 'other'
};

export const contactNums = {
  multiple: '2',
  one: '1',
  zero: '0'
};

export const categories = {
  agent: 11,
  client: 12,
  feature: 14,
  login: 13,
  market: 2,
  media: 10,
  multiMedia: 32,
  oneMedia: 31,
  opinion: 15,
  other: 99,
  search: 3,
  service: 1
};

export const negotiationStatus = {
  decline: 99,
  inquiries: 1,
  invoice: 8,
  like: 2,
  likeApproved: 3,
  likeRejected: 98,
  negotiation: 5,
  order: 6,
  orderApproval: 7,
  posted: 10,
  preparation: 9,
  proposalPreparation: 4
};

export const chatType = {
  contact: 4,
  decline: 99,
  file: 2,
  invoice: 8,
  like: 5,
  orderDetail: 7,
  proposalFile: 6,
  system: 3,
  user: 1
};
